// Section Imports

import CheckoutSection from "./CheckoutSection";

const CheckoutPage = () => {
  return (
    <div className="bg-transparent w-full p-4 ">
      <div className="bg-transparent">
        <CheckoutSection />
      </div>
    </div>
  );
};

export default CheckoutPage;
